module.exports = __webpack_public_path__ + "static/media/icon_opportunistic.8ff40ff1.svg";